import FormData from "csi/action/FormData";
import reflection from "csi/reflection";
import NewFrom from "csi/table/NewFrom";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const NewFromWBSTemplate = declare(NewFrom, {

	/**
	 * @override
	 * Multiple selections are allowed if the type of WbsHolder is in MultipleWBSesAllowedOn class setting of Wbs
	 */
	onFormData(fd: FormData): void {
		let multipleAllowed: boolean = false;
		const setting = reflection.getClassSetting("Wbs", "MultipleWBSesAllowedOn");
		if (setting) {
			const wbsHolder = this.getParent();
			const enumToSearch = xml.enumCreate("ApplicableForTypes", wbsHolder.$Type);
			multipleAllowed = setting.includes(enumToSearch);
		}
		fd.m_bSelectOne = !multipleAllowed;
	},
});
export = NewFromWBSTemplate;